import React, { useState } from "react";

export default function ChangePW() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("info"); // 'ok' | 'error' | 'info'

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg("");
    setMsgType("info");

    if (!currentPassword || !newPassword) {
      setMsg("Please fill both password fields.");
      setMsgType("error");
      return;
    }
    if (newPassword !== confirm) {
      setMsg("New passwords do not match.");
      setMsgType("error");
      return;
    }

    setBusy(true);
    try {
      const token = sessionStorage.getItem("accessToken");
      const res = await fetch("/api/auth/change-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        credentials: "include",
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);

      setMsg("Password updated ✓");
      setMsgType("ok");
      setCurrentPassword("");
      setNewPassword("");
      setConfirm("");
    } catch (err) {
      setMsg(err.message || "Failed to change password");
      setMsgType("error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container">
      <div className="card">
        <h2 className="section-title" style={{ marginTop: 0, marginBottom: 8 }}>
          Change Password
        </h2>
        <div className="qp-divider" />

        <form onSubmit={handleSubmit} className="qp-form" style={{ marginTop: 12 }}>
          {/* Current Password */}
          <div className="row" style={{ gap: 12, alignItems: "center" }}>
            <label className="qp-label" style={{ minWidth: 180 }}>Current password</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter current password"
            />
          </div>

          {/* New Password */}
          <div className="row" style={{ gap: 12, alignItems: "center", marginTop: 10 }}>
            <label className="qp-label" style={{ minWidth: 180 }}>New password</label>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </div>

          {/* Confirm New Password */}
          <div className="row" style={{ gap: 12, alignItems: "center", marginTop: 10 }}>
            <label className="qp-label" style={{ minWidth: 180 }}>Confirm new password</label>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Re-enter new password"
            />
          </div>

          {/* Message */}
          {msg && (
            <div
              className={`qp-banner ${msgType === "ok" ? "qp-banner--ok" : msgType === "error" ? "qp-banner--error" : ""}`}
              style={{ marginTop: 12 }}
            >
              {msg}
            </div>
          )}

          {/* Actions */}
          <div
            className="qp-actions"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginTop: 14,
            }}
          >
            <button
              type="button"
              className="btn cancel"
              onClick={() => window.history.back()}
            >
              Cancel
            </button>
            <button type="submit" className="btn" disabled={busy}>
              {busy ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

